import { render, staticRenderFns } from "./EditTaxonomyLabel.vue?vue&type=template&id=3771a6c9&"
import script from "./EditTaxonomyLabel.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyLabel.vue?vue&type=script&lang=js&"
import style0 from "./EditTaxonomyLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports